import { InjectionToken } from '@angular/core';
import { ApplicationNames } from '@ddt-web/domain';

import { ConfigVariants } from '../enums/config-variants.enum';
import { AppBootstrapServiceFlags } from '../models/app-bootstrap-service-flags.interface';

export type ApplicationName = keyof ApplicationNames;
export const APPLICATION_NAME_TOKEN = new InjectionToken<ApplicationName>('APPLICATION_NAME');
export const APPLICATION_SUITE_TOKEN = new InjectionToken<string>('APPLICATION_SUITE');

export const APP_STORE_CONFIG_TOKEN = new InjectionToken<string>('APP_STORE_CONFIG');
export const MODELS_STORE_NAME_TOKEN = new InjectionToken<string>('MODELS_STORE_NAME');
export const AREAS_TO_EXPLORE_CONFIG_TOKEN = new InjectionToken<string>('AREAS_TO_EXPLORE_CONFIG');
export const APP_BOOTSTRAP_SERVICE_FLAGS = new InjectionToken<AppBootstrapServiceFlags>('APP_SERVICE_FLAGS');
export const CUSTOM_CONFIG_VARIANTS_TOKEN = new InjectionToken<Array<ConfigVariants>>('CUSTOM_CONFIG_VARIANTS');
export const IS_PUBLIC_APPLICATION = new InjectionToken<boolean>('PUBLIC_APPLICATION');
export const MAX_PORTFOLIOS_LIMIT_TOKEN = new InjectionToken<number>('MAX_PORTFOLIOS_LIMIT_TOKEN');
export const MONITORING_STORE_CONFIG_TOKEN = new InjectionToken<string>('MONITORING_STORE_CONFIG');
